export default __webpack_public_path__ + "static/salebg-91bb92848674415556513ec5b4c09006.jpg";